/* eslint-disable import/no-named-as-default-member */
import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

import { DEFAULT_LOCALE } from './constants'

const isDevMode = import.meta.env.MODE === 'development'

i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
        fallbackLng: DEFAULT_LOCALE,
        lng: DEFAULT_LOCALE,
        debug: isDevMode,
        interpolation: {
            escapeValue: false,
        },
    })

export default i18n
